import React from 'react';
import styled from 'styled-components';
import { alignItems } from 'styled-system';
import { toArray } from '../../helpers/toArray';
import { buildResponsiveStyles } from '../../helpers/buildResponsiveStyles';
const Component = styled.div({
    '& > *': {
        marginTop: 0,
        marginBottom: 0,
    },
}, ({ layout, margin, theme, noZeroMargin }) => {
    const layoutArray = toArray(layout);
    const marginArray = toArray(margin);
    const size = Math.max(layoutArray.length, marginArray.length);
    const styles = Array.from({ length: size }).map((_, i) => {
        const layout = byIndexOrLast(layoutArray, i);
        const margin = byIndexOrLast(marginArray, i);
        if (layout === 'hidden') {
            return {
                display: 'none',
            };
        }
        if (layout === 'horizontal') {
            return {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                '& > * + *': {
                    ...(!noZeroMargin ? { marginTop: 0 } : {}),
                    marginLeft: theme.space[margin],
                },
            };
        }
        return {
            display: 'block',
            '& > * + *': {
                ...(!noZeroMargin ? { marginLeft: 0 } : {}),
                marginTop: theme.space[margin],
            },
        };
    });
    return buildResponsiveStyles(styles, theme);
}, alignItems);
export const Stack = ({ htmlAttrs = {}, ...rest }) => {
    return React.createElement(Component, { ...htmlAttrs, ...rest });
};
Stack.defaultProps = {
    layout: 'vertical',
    margin: 'x16',
};
function byIndexOrLast(array, idx) {
    return array[idx] || array[array.length - 1];
}
//# sourceMappingURL=index.js.map